/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CountryList } from '../models/CountryList';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CountryService {
    /**
     * Get Countries
     * Get all countries
     * :return: List of countries
     * @returns CountryList Successful Response
     * @throws ApiError
     */
    public static getCountriesCountryGet(): CancelablePromise<CountryList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/country/',
        });
    }
}
